'use client'
import { Button } from '@/components/ui/button'
import { ChevronLeft, ChevronRight } from 'lucide-react'

const BUTTON_BASE_CLASS =
  'm-0 p-3 bg-white w-12 h-12 border-0 rounded-full shadow-md hover:shadow-lg hover:bg-gray-50 transition-all'

// Individual button components for flexible layouts
interface NavButtonProps {
  onClick: () => void
  disabled?: boolean
  className?: string
  hideOnMobile?: boolean
}

export const NavPrevButton = ({
  onClick,
  disabled = false,
  className = '',
  hideOnMobile = true,
}: NavButtonProps) => (
  <Button
    disabled={disabled}
    className={`${BUTTON_BASE_CLASS} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${
      hideOnMobile ? 'hidden lg:block' : ''
    } ${className}`}
    onClick={onClick}
  >
    <ChevronLeft className="w-6 h-6 text-[#1555A3]" />
  </Button>
)

export const NavNextButton = ({
  onClick,
  disabled = false,
  className = '',
  hideOnMobile = true,
}: NavButtonProps) => (
  <Button
    disabled={disabled}
    className={`${BUTTON_BASE_CLASS} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${
      hideOnMobile ? 'hidden lg:block' : ''
    } ${className}`}
    onClick={onClick}
  >
    <ChevronRight className="w-6 h-6 text-[#1555A3]" />
  </Button>
)

// Combined navigation component
interface CarouselNavigationProps {
  goToPrevSlide: () => void
  goToNextSlide: () => void
  className?: string
  variant?: 'overlay' | 'inline'
  hideOnMobile?: boolean
}

const CarouselNavigation = ({
  goToPrevSlide,
  goToNextSlide,
  className = '',
  variant = 'overlay',
  hideOnMobile = true,
}: CarouselNavigationProps) => {
  const isOverlay = variant === 'overlay'

  return (
    <div
      className={`${
        isOverlay
          ? 'absolute top-1/2 -translate-y-1/2 left-0 right-0 z-10 pointer-events-none'
          : 'flex items-center gap-2'
      } ${hideOnMobile ? 'hidden md:block' : ''} ${className}`}
    >
      <div className={isOverlay ? 'flex justify-between px-0 -mx-6' : 'flex items-center gap-2'}>
        <Button
          className={`${isOverlay ? 'pointer-events-auto' : ''} ${BUTTON_BASE_CLASS}`}
          onClick={goToPrevSlide}
        >
          <ChevronLeft className="w-6 h-6 text-[#1555A3]" />
        </Button>
        <Button
          className={`${isOverlay ? 'pointer-events-auto' : ''} ${BUTTON_BASE_CLASS}`}
          onClick={goToNextSlide}
        >
          <ChevronRight className="w-6 h-6 text-[#1555A3]" />
        </Button>
      </div>
    </div>
  )
}

export default CarouselNavigation
